/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'linkDataSource.accessInstructions': '액세스 권한을 요청하려면 사이트 관리자에게 문의하세요.',
  'linkDataSource.accessRequired': '이 콘텐츠에 대한 액세스 권한이 없습니다',
  'linkDataSource.accessRequiredWithSite': '다음 사이트에 대한 액세스 권한이 없습니다.',
  'linkDataSource.assets.configModal.aqlSearchInput.helpTooltipText': '구문 도움말',
  'linkDataSource.assets.configModal.aqlSearchInput.placeholder': 'AQL로 검색',
  'linkDataSource.assets.configModal.objectSchemaSelect.label': '스키마 선택',
  'linkDataSource.assets.configModal.objectSchemaSelect.placeholder': '스키마 선택',
  'linkDataSource.assets.configModal.objectSchemaSelect.schemaRequired': '스키마가 필요합니다',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.learnMoreLink': 'AQL을 사용한 검색에 대해 자세히 알아보세요.',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchDescription': '입력을 시작하거나 AQL을 사용하여 검색합니다.',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchTitle': '개체 검색',
  'linkDataSource.assets.configmodal.insertIssuesButtonText': '{objectsCount, plural, other {개체 삽입}}',
  'linkDataSource.assets.configmodal.insertObjectsTitle': '다음의 개체 삽입',
  'linkDataSource.assets.configmodal.updateObjectsButtonText': '표 업데이트',
  'linkDataSource.basic-filter.assignee.label': '담당자',
  'linkDataSource.basic-filter.dropdown.select.assignee.unassigned': '할당되지 않음',
  'linkDataSource.basic-filter.dropdown.select.placeholder': '검색',
  'linkDataSource.basic-filter.error-message': '문제가 발생했습니다',
  'linkDataSource.basic-filter.footer.pagination-details': '{currentDisplayCount}/{totalCount}',
  'linkDataSource.basic-filter.loading-message': '로드 중...',
  'linkDataSource.basic-filter.no-options-message': '일치하는 항목 없음',
  'linkDataSource.basic-filter.project.label': '프로젝트',
  'linkDataSource.basic-filter.showMoreButton': '더 보기',
  'linkDataSource.basic-filter.status.label': '상태',
  'linkDataSource.basic-filter.type.label': '유형',
  'linkDataSource.checkConnection': '연결을 확인하고 새로 고치거나 나중에 다시 시도하세요.',
  'linkDataSource.clol-basic-filter.editedOrCreatedBy.label': '편집한 사용자 또는 만든 사용자',
  'linkDataSource.column-picker.no-all-items-shown-message.line-1': '검색 결과가 너무 많습니다.',
  'linkDataSource.column-picker.no-all-items-shown-message.line-2': '더 구체적인 키워드로 다시 시도하세요.',
  'linkDataSource.column-picker.search': '필드 검색',
  'linkDataSource.column-picker.tooltip': '열 구성',
  'linkDataSource.configmodal.basicTextSearchPlaceholder': '키워드로 이슈 검색',
  'linkDataSource.configmodal.basicTextSearchPlaceholder-issue-term-refresh': '키워드로 업무 항목 검색',
  'linkDataSource.configmodal.cancelButtonText': '취소',
  'linkDataSource.confluence-search.configmodal.cancelButtonText': '취소',
  'linkDataSource.confluence-search.configmodal.date.range.after.label': '{date} 이후',
  'linkDataSource.confluence-search.configmodal.date.range.any.time': '언제든지',
  'linkDataSource.confluence-search.configmodal.date.range.before.label': '{date} 이전',
  'linkDataSource.confluence-search.configmodal.date.range.custom': '사용자 지정',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.end': '시작일은 종료일 이전이어야 합니다',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.today': '시작일은 미래일 수 없습니다',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.to.after.today': '종료 날짜는 미래일 수 없습니다',
  'linkDataSource.confluence-search.configmodal.date.range.error': '날짜 범위 오류',
  'linkDataSource.confluence-search.configmodal.date.range.from': '시작',
  'linkDataSource.confluence-search.configmodal.date.range.input.placeholder': '날짜 선택',
  'linkDataSource.confluence-search.configmodal.date.range.last.month': '지난 30일',
  'linkDataSource.confluence-search.configmodal.date.range.last.week': '지난 7일',
  'linkDataSource.confluence-search.configmodal.date.range.last.year': '지난해',
  'linkDataSource.confluence-search.configmodal.date.range.title': '마지막 업데이트',
  'linkDataSource.confluence-search.configmodal.date.range.to': '종료',
  'linkDataSource.confluence-search.configmodal.date.range.to.Label': '~',
  'linkDataSource.confluence-search.configmodal.date.range.today': '오늘',
  'linkDataSource.confluence-search.configmodal.date.range.update.button': '업데이트',
  'linkDataSource.confluence-search.configmodal.date.range.yesterday': '어제',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitle': 'Confluence 목록 삽입',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitleManySites': '다음에서 Confluence 목록 삽입',
  'linkDataSource.confluence-search.configmodal.insertResultsButtonText': '결과 삽입',
  'linkDataSource.confluence-search.configmodal.placeholder.issues': '결과 ###개',
  'linkDataSource.confluence-search.configmodal.searchLabel': '키워드를 입력하여 페이지, 첨부 파일 등을 찾으세요',
  'linkDataSource.confluence-search.no.confluence.sites.access.description': '액세스를 요청하려면 관리자에게 문의하세요.',
  'linkDataSource.confluence-search.no.confluence.sites.access.title': 'Confluence 사이트에 대한 액세스 권한이 없습니다',
  'linkDataSource.datasource.table.authConnectButtonText': '연결',
  'linkDataSource.datasource.table.authScreenDescriptionText': '{providerName} 계정을 연결하여 Atlassian 제품 전반에서 공동 작업하세요.',
  'linkDataSource.datasource.table.authScreenHeaderText': '{providerName} 계정 연결',
  'linkDataSource.datasource.table.learnMoreAboutSmartLinks': '스마트 링크에 대해 자세히 알아보세요.',
  'linkDataSource.issue-line-table.error-403-description': '이 항목을 편집하려면 적절한 권한이 필요합니다.',
  'linkDataSource.issue-line-table.error-403-title': '변경 사항 저장되지 않음',
  'linkDataSource.issue-line-table.error-generic-description': '업데이트를 완료하는 동안 문제가 발생했습니다. 몇 분 후에 다시 시도하세요. 이 문제가 지속되면 지원 팀에 문의하세요.',
  'linkDataSource.issue-line-table.error-generic-title': '문제가 발생했습니다',
  'linkDataSource.issue-line-table.fetch-action-error-generic-description': '몇 분 후에 다시 시도하세요. 프로젝트 설정을 확인하거나 이 문제가 지속되면 지원 팀에 문의하세요.',
  'linkDataSource.issue-line-table.fetch-action-error-generic-title': '옵션을 가져오는 동안 문제가 발생했습니다',
  'linkDataSource.issue-line-table.unwrap-text': '텍스트 줄 바꿈 해제',
  'linkDataSource.issue-line-table.wrap-text': '텍스트 줄 바꿈',
  'linkDataSource.checkConnectionWithSource': '연결을 확인하고 새로 고치거나 <a>Jira에서 이 쿼리를 열어</a> 검토하세요.',
  'linkDataSource.jira-issues.configmodal.basicModeSwitchDisabledTooltipText': '이 쿼리는 기본으로 전환할 수 없습니다.',
  'linkDataSource.jira-issues.configmodal.basicModeText': '기본',
  'linkDataSource.jira-issues.configmodal.basicTextSearchPlaceholder-issue-term-refresh': '키워드로 업무 항목 검색',
  'linkDataSource.site-selector.configmodal.chooseSite': '사이트 선택',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText': '이슈 삽입',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText-issue-term-refresh': '업무 항목 삽입',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle': 'Jira 이슈 삽입',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle-issue-term-refresh': 'Jira 업무 항목 삽입',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites': '다음의 Jira 이슈 삽입',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites-issue-term-refresh': '다음의 Jira 업무 항목 삽입',
  'linkDataSource.jira-issues.configmodal.placeholder.issues-issue-term-refresh': '### 업무 항목',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkDescription': '검색 결과 수를 인라인 스마트 링크로 표시합니다',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkLabel': '인라인 링크',
  'linkDataSource.jira-issues.configmodal.viewModeListDescription': '검색 결과를 목록으로 표시합니다',
  'linkDataSource.jira-issues.configmodal.viewModeListLabel': '목록',
  'linkDataSource.jira-issues.learnMoreLink': 'JQL로 검색하는 방법 알아보기',
  'linkDataSource.no.jira.sites.access.description': '액세스를 요청하려면 관리자에게 문의하세요.',
  'linkDataSource.no.jira.sites.access.title': 'Jira 사이트에 대한 액세스 권한이 없습니다',
  'linkDataSource.noResultsFound': '결과 없음',
  'linkDataSource.refresh': '새로 고침',
  'linkDataSource.jira-issues.searchDescription-basic': '삽입할 이슈를 키워드로 검색하세요.',
  'linkDataSource.jira-issues.searchDescription-jql': 'JQL(Jira Query Language)을 사용하여 이슈를 검색하세요.',
  'linkDataSource.jira-issues.searchJiraTitle': 'Jira 이슈 검색',
  'linkDataSource.unableToLoadItems': '항목을 로드할 수 없음',
  'linkDataSource.unableToLoadResults': '결과를 로드할 수 없음',
  'linkDataSource.modal-initial-state.beta': '베타',
  'linkDataSource.modal-initial-state.confluenceSearchTitle': 'Confluence 페이지 검색',
  'linkDataSource.modal-initial-state.jiraSearchTitle': 'Jira 이슈 검색',
  'linkDataSource.modal-initial-state.searchDescription-basic-issue-term-refresh': '삽입할 업무 항목을 키워드로 검색합니다.',
  'linkDataSource.modal-initial-state.searchDescription-confluence': '삽입할 페이지를 키워드로 검색합니다.',
  'linkDataSource.modal-initial-state.searchDescription-jql-issue-term-refresh': 'JQL(Jira 쿼리 언어)을 사용하여 업무 항목을 검색하세요.',
  'linkDataSource.modal-initial-state.searchTitle-issue-term-refresh': 'Jira 업무 항목 검색',
  'linkDataSource.render-type.boolean.false': '아니요',
  'linkDataSource.render-type.boolean.true': '예',
  'linkDataSource.render-type.user.default.display.name': '할당되지 않음',
  'linkDataSource.search.configmodal.issueCountText': '{searchCount, plural, other {{searchCount,number}개의 이슈}}',
  'linkDataSource.search.configmodal.issueCountText-issue-term-refresh': '{searchCount, plural, other {{searchCount,number}개의 업무 항목}}',
  'linkDataSource.search.configmodal.itemCountText': '{searchCount, plural, other {{searchCount,number}개의 항목}}',
  'linkDataSource.search.configmodal.resultCountText': '{searchCount, plural, other {{searchCount,number}개의 결과}}',
  'linkDataSource.table-footer.date_formatter.under_one_minute': '방금 동기화',
  'linkDataSource.table-footer.date_formatter.under_over_minute': '{date}에 동기화',
  'linkDataSource.table-footer.item': '{itemCount, plural, other {항목}}',
  'linkDataSource.table-footer.loading': '로드 중...',
  'linkDataSource.table-footer.power-by-jsm': 'Jira Service Management의 자산에서 제공',
  'linkDataSource.table-footer.powered-by-assets': '자산 기반',
  'linkDataSource.table-footer.refresh': '새로 고침'
};